module.exports = __webpack_public_path__ + "static/media/01.f4546a0c.mp4";